const isDev = window &&
    window.location && (
        window.location.hostname === "localhost" ||
        window.location.port === "3000"
    );

export default isDev;